import { render, staticRenderFns } from "./QuotesModalVideo.vue?vue&type=template&id=7f967d1b&scoped=true"
import script from "./QuotesModalVideo.vue?vue&type=script&lang=js"
export * from "./QuotesModalVideo.vue?vue&type=script&lang=js"
import style0 from "./QuotesModalVideo.vue?vue&type=style&index=0&id=7f967d1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f967d1b",
  null
  
)

export default component.exports